import React from 'react';

import PropTypes from 'prop-types';
import './InfoPanel.scss';

var InfoPanel = function InfoPanel(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: 'sb-header__info-panel' },
    children
  );
};

InfoPanel.propTypes = {
  children: PropTypes.node
};

export default InfoPanel;
//# sourceMappingURL=InfoPanel.js.map